import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RouterModule, Routes} from '@angular/router';
import {ProductListComponent} from '@app/marketplace/products/product-list/product-list.component';
import {StoreListComponent} from '@app/marketplace/stores/store-list/store-list.component';
import {StoreDetailsComponent} from '@app/marketplace/stores/store-details/store-details.component';

const routes: Routes = [
  {
    path: '',
    component: StoreListComponent,
  },
  {
    path: ':id',
    component: StoreDetailsComponent,
  },
];

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StoresRoutingModule { }
